import { atom } from 'recoil';
import type { SearchFilterType } from '@hooks/getSearchResult';

export const searchValueState = atom<string | undefined>({
  key: 'searchValueState',
  default: '',
});

export const searchCountState = atom<number | undefined>({
  key: 'searchCountState',
  default: 0,
});

/** 검색 필터 복수 선택 상태 — ['all']이 기본값 */
export const searchFiltersState = atom<SearchFilterType[]>({
  key: 'searchFiltersState',
  default: ['all'],
});

/** 정확히 일치 검색 토글 */
export const searchExactMatchState = atom<boolean>({
  key: 'searchExactMatchState',
  default: false,
});
